import React, { FC, useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import colors from '../../utils/colors';
import { RESET_TRIALS } from '../../utils/constants/labels';
import PageHeader from '../common/layout/PageHeader';
import { api } from '../../api/api';
import { StyledAntTable } from '../common/table/Table.style';

const columns = [
  {
    title: 'Date',
    dataIndex: 'date',
    width: '10%',
    defaultSortOrder: 'descend'
  },
  {
    title: 'Total',
    dataIndex: 'usersGiven',
    width: '10%'
  },
  {
    title: 'Restarted',
    dataIndex: 'usersRestarted',
    width: '10%'
  },
  {
    title: 'Subscribed',
    dataIndex: 'usersSubscribed',
    width: '10%',
  }
];

type Props = {};

type State = {
  date: string;
  usersGiven: number;
  usersRestarted: number;
  usersSubscribed: number;
}[];

const ResetTrials: FC<Props> = ({}) => {
  const [data, setData] = useState<State>([]);
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = useCallback(async () => {
    const response = await api.getResetTrials();
    if (response.ok) {
      const campaigns = response.data?.resetTrialCampaigns;
      if (!campaigns) return;
      setData(Object.keys(campaigns).map(i => ({ date: i, ...campaigns[i]})));
    }
  }, []);

  return (
    <Container>
      <PageHeader title={RESET_TRIALS} />
      <StyledAntTable
        // @ts-ignore
        columns={columns}
        dataSource={data}
      />
    </Container>
  );
};

export default ResetTrials;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex: 1;
  background-color: ${colors.white};
  position: relative;
`;
